













import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { ContentSet } from "@scrile/api-provider/dist/api/ContentSetProvider";
import { $t } from "@/lib/i18nHelpers";
import { format, parse } from "@/lib/time";
import { FormFields, FormValues } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseForm from "@/components/BaseForm";

@Component({ name: "SchedulePostView", components: { BaseForm, BaseConfirm, BaseButton } })
export default class SchedulePostView extends Vue {
  @Prop({ type: Object, required: true })
  public readonly postData!: ContentSet;

  @Prop({ type: Boolean, required: true })
  public readonly show!: boolean;

  public saving = false;

  public values: FormValues = {};

  get fields(): FormFields {
    return [
      {
        name: "date",
        label: $t("Date"),
        type: "date",
      },
      {
        name: "time",
        label: $t("Time"),
        type: "time",
      },
    ];
  }

  public onSetNow(e: Event | null, date = new Date()) {
    this.values = {
      date: format(date, "yyyy-MM-dd"),
      time: format(date, "HH:mm"),
    };
    this.onSave();
  }

  public onSave() {
    const date = parse(`${this.values.date} ${this.values.time}`, "yyyy-MM-dd HH:mm", new Date());
    this.$emit("save", date);
  }

  public onClose() {
    this.onSetNow(null, (this.postData.scheduleTime && new Date(this.postData.scheduleTime)) || undefined);
    this.$emit("close");
  }

  public created() {
    this.onSetNow(null, (this.postData.scheduleTime && new Date(this.postData.scheduleTime)) || undefined);
  }
}
